import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createBlock as _createBlock, createVNode as _createVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "row no-gutters mb-4"
};
const _hoisted_2 = { class: "row" };
const _hoisted_3 = {
    key: 1,
    class: "row mb-xl-4 mb-3"
};
const _hoisted_4 = { class: "col-12" };
const _hoisted_5 = { class: "col-12 bg-white border rounded" };
const _hoisted_6 = { class: "row" };
const _hoisted_7 = { class: "col-12 pt-3 text-right" };
const _hoisted_8 = {
    class: "font4 strong pr-md-3 pr-1",
    style: { "hyphens": "auto" }
};
const _hoisted_9 = {
    key: 0,
    class: "row"
};
const _hoisted_10 = {
    key: 1,
    class: "row"
};
const _hoisted_11 = {
    key: 2,
    class: "row"
};
const _hoisted_12 = {
    key: 3,
    class: "row"
};
const _hoisted_13 = { class: "col-12 pb-4 pt-0 text-right font7-responsive pointerhover" };
const _hoisted_14 = {
    key: 2,
    class: "row"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_product_box_big = _resolveComponent("product-box-big");
    const _component_formatted_price = _resolveComponent("formatted-price");
    const _component_open_popup_button = _resolveComponent("open-popup-button");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        (!_ctx.isLogin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
                    _createElementVNode("div", {
                        class: "col-12 bg-white border rounded py-3 pl-3 font7-responsive",
                        style: { "border-left": "8px solid #a4ff78 !important" }
                    }, [
                        _createElementVNode("i", { class: "icon-brand_user font5" }),
                        _createTextVNode(" Hast Du bereits ein Nutzerkonto? "),
                        _createElementVNode("span", {
                            class: "strong text-underline text-uppercase font-italic needs_login",
                            style: { "cursor": "pointer" }
                        }, " JETZT EINLOGGEN ")
                    ], -1)
                ]))]))
            : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.current_products, (cart_item, index) => {
                return (_openBlock(), _createBlock(_component_product_box_big, {
                    "cart-item": cart_item,
                    index: index,
                    key: cart_item.id,
                    class: _normalizeClass(_ctx.current_products.length > 1 ? 'col-xxl-6' : '')
                }, null, 8, ["cart-item", "index", "class"]));
            }), 128))
        ]),
        (_ctx.isCartFilled)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("div", _hoisted_7, [
                                _createElementVNode("span", _hoisted_8, [
                                    _cache[1] || (_cache[1] = _createTextVNode(" Gesamtsumme: ", -1)),
                                    _createVNode(_component_formatted_price, {
                                        class: "d-inline-block",
                                        price: _ctx.total
                                    }, null, 8, ["price"])
                                ])
                            ])
                        ]),
                        (_ctx.currentShippingIdentifier === 'flat')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [...(_cache[2] || (_cache[2] = [
                                    _createElementVNode("div", { class: "col-12 pb-1 pt-1 text-right" }, [
                                        _createElementVNode("span", { class: "font7-responsive pr-md-3 pr-1 fc-gray1 text-right d-lg-inline-block" }, [
                                            _createTextVNode(" zzgl. Versand: 3,99 € "),
                                            _createElementVNode("br"),
                                            _createElementVNode("div", { class: "pt-2 text-right" }, "Kostenloser Versand ab 30 €")
                                        ])
                                    ], -1)
                                ]))]))
                            : _createCommentVNode("", true),
                        (_ctx.currentShippingIdentifier === 'flat_free')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [...(_cache[3] || (_cache[3] = [
                                    _createElementVNode("div", { class: "col-12 pb-1 pt-2 text-right font7-responsive" }, [
                                        _createTextVNode(" Versand: "),
                                        _createElementVNode("span", { class: "badge badge-light-green p-y-1 p-x-2 mr-md-3 font-weight-normal font8-responsive" }, " Kostenlos ")
                                    ], -1)
                                ]))]))
                            : _createCommentVNode("", true),
                        (_ctx.currentShippingIdentifier === 'express')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [...(_cache[4] || (_cache[4] = [
                                    _createElementVNode("div", { class: "col-12 pb-1 pt-1 text-right" }, [
                                        _createElementVNode("span", { class: "font7-responsive pr-md-3 pr-1 fc-gray1 text-right d-lg-inline-block" }, [
                                            _createTextVNode(" zzgl. Deiner Auswahl: "),
                                            _createElementVNode("br"),
                                            _createTextVNode(" Expressversand: 6,99 € "),
                                            _createElementVNode("br"),
                                            _createElementVNode("div", { class: "pt-2 text-right" }, "Diese Auswahl kannst Du im Checkout noch ändern")
                                        ])
                                    ], -1)
                                ]))]))
                            : _createCommentVNode("", true),
                        (_ctx.hasWarrantyForAll)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                _createElementVNode("div", _hoisted_13, [
                                    _createVNode(_component_open_popup_button, { "popup-name": "guaranteePopup" }, {
                                        default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                                                _createTextVNode(" 36 Monate Garantie ", -1),
                                                _createElementVNode("i", { class: "icon-fragezeichen fc-gray1 mr-2" }, null, -1),
                                                _createElementVNode("span", { class: "badge badge-light-green p-y-1 p-x-2 mr-md-3 font-weight-normal font8-responsive" }, " Inklusive ", -1)
                                            ]))]),
                                        _: 1
                                    })
                                ])
                            ]))
                            : _createCommentVNode("", true),
                        _cache[6] || (_cache[6] = _createStaticVNode("<div class=\"row px-3 p-2 border-top\"><div class=\"placeholder order-1 col-lg-4 d-lg-block d-none col-md-6 col-12\"></div><div class=\"p-2 col-lg-4 col-md-6 order-2\"><a href=\"/kaufen\" class=\"buttonBase buttonBlueInverted font6-responsive\" style=\"width:100%;\"> Weiter einkaufen </a></div><div class=\"order-3 p-2 col-lg-4 col-md-6 col-12\"><a href=\"/kaufen/checkout\" title=\"Zur Kasse\" id=\"buy-now\" class=\"buttonBase buttonGreen font6-responsive [ JS_Sticky_Anchor_To_Checkout ]\" style=\"width:100%;\"> Zur Kasse </a></div></div>", 1))
                    ])
                ])
            ]))
            : _createCommentVNode("", true),
        (_ctx.isCartFilled === false)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [...(_cache[7] || (_cache[7] = [
                    _createStaticVNode("<div class=\"col-12\"><div class=\"bg-white border rounded mb-3 text-center\"><h2 class=\"h5-responsive strong px-lg-3 pt-5\">Du hast noch keine Produkte im Warenkorb.</h2><div class=\"mt-4 pb-4\"><a href=\"/kaufen\" class=\"buttonBase buttonBlueInverted mb-3\" style=\"width:400px;max-width:100%;\"> Jetzt Produkte entdecken </a></div></div></div>", 1)
                ]))]))
            : _createCommentVNode("", true)
    ], 64));
}
